import React from 'react';
import { createPortal } from 'react-dom';

const FareDetailsDialog = ({ isOpen, onClose, fareType }) => {
  if (!isOpen) return null;

  const getFareDetails = (type) => {
    switch (type) {
      case 'Basic Economy':
        return {
          title: 'Basic Economy',
          details: [
            {
              section: 'Pay to check bags',
              content: 'On American Airlines operated flights, 1 personal item and 1 carry-on bag are free of charge.\nFor travel on partner airlines within the U.S. or to / from the U.S. or Canada, the marketing airline for the first flight segment in your trip sets the bag allowance and fees for your entire trip.\n'
            },
            {
              section: 'Pay for a Main Cabin seat',
              content: 'Seat selection is subject to availability.\nComplimentary for AAdvantage® members based on status.\nFee may apply for flights operated by partner airline.\nSeat selection varies by the operating airline. On American Airlines operated flights, if you don\'t choose seats, we\'ll assign them at check-in free of charge. For partner-operated flights, see the airline\'s website for details.\nIf you\'re traveling with a child and are unable to choose seats or don\'t want to pay for seats, we\'ll assign seats so children under 15 are sitting next to at least 1 adult. Families traveling , Opens in a new window.'
            },
            {
              section: 'Pay for an extra legroom seat',
              content: ''
            },
            {
              section: 'Pay for a Preferred Seat',
              content: 'Seat selection is subject to availability.\nComplimentary for AAdvantage® members based on status.\nFee may apply for flights operated by partner airline.'
            },
            {
              section: 'Board in last group',
              content: 'Applicable only on American Airlines operated flights.'
            },
            {
              section: 'Pay to choose another same-day flight',
              content: 'Same-day travel changes subject to availability.\nLearn about same-day travel changes. , Opens in a new window.'
            }
          ]
        };
      case 'Main':
        return {
          title: 'Main',
          details: [
            {
              section: 'Pay to check bags',
              content: 'On American Airlines operated flights, 1 personal item and 1 carry-on bag are free of charge.\nFor travel on partner airlines within the U.S. or to / from the U.S. or Canada, the marketing airline for the first flight segment in your trip sets the bag allowance and fees for your entire trip.\n'
            },
            {
              section: 'Choose a Main Cabin seat',
              content: 'Seat selection is subject to availability.\nFee may apply for flights operated by partner airline.\nSeat selection varies by the operating airline. On American Airlines operated flights, if you don\'t choose seats, we\'ll assign them at check-in free of charge. For partner-operated flights, see the airline\'s website for details.\nIf you\'re traveling with a child and are unable to choose seats or don\'t want to pay for seats, we\'ll assign seats so children under 15 are sitting next to at least 1 adult. Families traveling , Opens in a new window.'
            },
            {
              section: 'Pay for an extra legroom seat',
              content: ''
            },
            {
              section: 'Pay for a Preferred Seat',
              content: 'Seat selection is subject to availability.\nComplimentary for AAdvantage® members based on status.\nFee may apply for flights operated by partner airline.\nSeat selection varies by the operating airline. For partner-operated flights, see the airline\'s website for details.'
            },
            {
              section: 'Board in general group (6-8)',
              content: 'Applicable only on American Airlines operated flights.'
            },
            {
              section: 'Changes allowed',
              content: 'Difference in ticket price may apply. Please review fare rules on the payment page for more information.'
            },
            {
              section: 'Pay to choose another same-day flight',
              content: 'Same-day travel changes subject to availability.\nLearn about same-day travel changes. , Opens in a new window.'
            },
            {
              section: 'Refund options',
              content: '\'Full refund to travel credit\' includes a refund of the full ticket amount. Please review detailed fare rules on the payment page.\n\'Full refund to original form of payment\' includes a refund of the full ticket amount. Please review detailed fare rules on the payment page.'
            },
            {
              section: 'Top pick',
              content: 'Most frequently booked.'
            }
          ]
        };
      case 'Main Plus':
        return {
          title: 'Main Plus',
          details: [
            {
              section: 'Check 1 bag free',
              content: 'On American Airlines operated flights, 1 personal item and 1 carry-on bag are free of charge.\nFor travel on partner airlines within the U.S. or to / from the U.S. or Canada, the marketing airline for the first flight segment in your trip sets the bag allowance and fees for your entire trip.\n'
            },
            {
              section: 'Choose a Main Cabin seat',
              content: 'Seat selection is subject to availability.\nFee may apply for flights operated by partner airline.\nSeat selection varies by the operating airline. On American Airlines operated flights, if you don\'t choose seats, we\'ll assign them at check-in free of charge. For partner-operated flights, see the airline\'s website for details.\nIf you\'re traveling with a child and are unable to choose seats or don\'t want to pay for seats, we\'ll assign seats so children under 15 are sitting next to at least 1 adult. Families traveling , Opens in a new window.'
            },
            {
              section: 'Choose an extra legroom seat',
              content: ''
            },
            {
              section: 'Choose a Preferred Seat',
              content: 'Seat selection is subject to availability.\nFee may apply for flights operated by partner airline.\nSeat selection varies by the operating airline. For partner-operated flights, see the airline\'s website for details.'
            },
            {
              section: 'Board earlier with Group 5',
              content: 'Applicable only on American Airlines operated flights.'
            },
            {
              section: 'Changes allowed',
              content: 'Difference in ticket price may apply. Please review fare rules on the payment page for more information.'
            },
            {
              section: 'Pay to choose another same-day flight',
              content: 'Same-day travel changes subject to availability.\nLearn about same-day travel changes. , Opens in a new window.'
            },
            {
              section: 'Refund options',
              content: '\'Full refund to travel credit\' includes a refund of the full ticket amount. Please review detailed fare rules on the payment page.'
            }
          ]
        };
      case 'Main Select':
        return {
          title: 'Main Select',
          details: [
            {
              section: 'Pay to check bags',
              content: 'On American Airlines operated flights, 1 personal item and 1 carry-on bag are free of charge.\nFor travel on partner airlines within the U.S. or to / from the U.S. or Canada, the marketing airline for the first flight segment in your trip sets the bag allowance and fees for your entire trip.\n'
            },
            {
              section: 'Choose a Main Cabin seat',
              content: 'Seat selection is subject to availability.\nFee may apply for flights operated by partner airline.\nSeat selection varies by the operating airline. On American Airlines operated flights, if you don\'t choose seats, we\'ll assign them at check-in free of charge. For partner-operated flights, see the airline\'s website for details.\nIf you\'re traveling with a child and are unable to choose seats or don\'t want to pay for seats, we\'ll assign seats so children under 15 are sitting next to at least 1 adult. Families traveling , Opens in a new window.'
            },
            {
              section: 'Choose an extra legroom seat',
              content: ''
            },
            {
              section: 'Choose a Preferred Seat',
              content: 'Seat selection is subject to availability.\nFee may apply for flights operated by partner airline.\nSeat selection varies by the operating airline. For partner-operated flights, see the airline\'s website for details.'
            },
            {
              section: 'Priority check-in and boarding access (Group 4)',
              content: 'Applicable only on American Airlines operated flights.\nAccess to Priority security lanes where available.'
            },
            {
              section: 'Changes allowed',
              content: 'Difference in ticket price may apply. Please review fare rules on the payment page for more information.'
            },
            {
              section: 'Choose another same-day flight',
              content: 'Same-day travel changes subject to availability.\nLearn about same-day travel changes. , Opens in a new window.'
            },
            {
              section: 'Refund options',
              content: '\'Full refund to original form of payment\' includes a refund of the full ticket amount. Please review detailed fare rules on the payment page.'
            }
          ]
        };
      case 'First':
        return {
          title: 'First',
          details: [
            {
              section: 'Check 2 bags free',
              content: 'On American Airlines operated flights, 1 personal item and 1 carry-on bag are free of charge.\nFor travel on partner airlines within the U.S. or to / from the U.S. or Canada, the marketing airline for the first flight segment in your trip sets the bag allowance and fees for your entire trip.\n'
            },
            {
              section: 'Choose our largest, most comfortable seat',
              content: 'Seat selection is subject to availability.\nSeat selection varies by the operating airline. On American Airlines operated flights, if you don\'t choose seats, we\'ll assign them at check-in free of charge. For partner-operated flights, see the airline\'s website for details.\nIf you\'re traveling with a child and are unable to choose seats or don\'t want to pay for seats, we\'ll assign seats so children under 15 are sitting next to at least 1 adult. Families traveling , Opens in a new window.'
            },
            {
              section: 'Priority check-in and boarding access',
              content: 'Applicable only on American Airlines operated flights.\nAccess to Priority security lanes where available.'
            },
            {
              section: 'Changes allowed',
              content: 'Difference in ticket price may apply. Please review fare rules on the payment page for more information.'
            },
            {
              section: 'Choose another same-day flight',
              content: 'Same-day travel changes subject to availability.\nLearn about same-day travel changes. , Opens in a new window.'
            },
            {
              section: 'Refund options',
              content: '\'Full refund to travel credit\' includes a refund of the full ticket amount. Please review detailed fare rules on the payment page.\n\'Full refund to original form of payment\' includes a refund of the full ticket amount. Please review detailed fare rules on the payment page.'
            }
          ]
        };
      default:
        return {
          title: type,
          details: [
            {
              section: 'Fare Benefits',
              content: 'This fare type includes various benefits and restrictions. Please contact customer service for detailed information about this fare class.'
            }
          ]
        };
    }
  };

  const fareDetails = getFareDetails(fareType);

  return createPortal(
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50 p-4" 
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" style={{ margin: '0 auto' }}>
        {/* Header */}
        <div className="sticky top-0 bg-white  p-4 flex items-center justify-between rounded-t-lg">
          <h2 className="text-[32px]  text-aa-dark-blue">{fareDetails.title}</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 border-2 border-aa-blue text-aa-blue rounded-full flex items-center justify-center hover:border-aa-dark-blue hover:text-aa-dark-blue transition-colors"
            aria-label="Close dialog"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="space-y-6">
            {fareDetails.details.map((detail, index) => (
              <div key={index}>
                {detail.section && (
                  <div className="mb-3">
                    <h3 className="font-semibold text-gray-900 text-base mb-3">
                      {detail.section}
                    </h3>
                  </div>
                )}
                {detail.content && (
                  <div className="mb-4">
                    <ol className="list-decimal space-y-2 text-sm text-gray-700 ml-4">
                      {detail.content.split('\n').map((line, lineIndex) => (
                        line.trim() && (
                          <li key={lineIndex} className="leading-relaxed">
                            {(() => {
                              if (line.includes('Learn about')) {
                                const parts = line.split('Learn about our ');
                                if (parts.length === 2) {
                                  return (
                                    <>
                                      {parts[0]}Learn about our{' '}
                                      <span className="text-blue-600 underline cursor-pointer hover:text-blue-800">
                                        {parts[1].replace(' , Opens in a new window.', '')}
                                        <svg className="inline w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                      </span>
                                    </>
                                  );
                                }
                              } else if (line.includes('Families traveling')) {
                                const parts = line.split('Families traveling');
                                if (parts.length === 2) {
                                  return (
                                    <>
                                      {parts[0]}
                                      <span className="text-blue-600 underline cursor-pointer hover:text-blue-800">
                                        Families traveling
                                        <svg className="inline w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                      </span>
                                    </>
                                  );
                                }
                              } else if (line.includes('same-day travel changes')) {
                                const parts = line.split('same-day travel changes');
                                if (parts.length === 2) {
                                  return (
                                    <>
                                      {parts[0]}
                                      <span className="text-blue-600 underline cursor-pointer hover:text-blue-800">
                                        same-day travel changes
                                        <svg className="inline w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                      </span>
                                    </>
                                  );
                                }
                              }
                              return line;
                            })()}
                          </li>
                        )
                      ))}
                    </ol>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-white px-6 py-4 border-t border-gray-200 rounded-b-lg">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-aa-blue text-white rounded hover:bg-aa-dark-blue transition-colors font-medium"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FareDetailsDialog;